import { SERVICE_ENDPOINTS, CONNECTION_MANAGEMENT_ENDPOINTS } from '../constants/endpoints';
import { getStageFromUrl } from './stageUtil';
import type { Region } from '../shared/contexts/RegionContext';

export const getServiceEndpoint = (): string => {
  const stage = getStageFromUrl();
  const endpoint = SERVICE_ENDPOINTS[stage];
  console.log('WinBot service endpoint:', endpoint);
  return endpoint;
};

export const getConnectionManagementEndpoint = (region: Region = 'global'): string => {
  const stage = getStageFromUrl();
  const endpoint = CONNECTION_MANAGEMENT_ENDPOINTS[region][stage];
  console.log('Connection Management endpoint:', endpoint, 'for region:', region);
  return endpoint;
};
